// extracted by mini-css-extract-plugin
export default {"root":"applications-components-common-LoaderModule-loader-module__root","loader":"applications-components-common-LoaderModule-loader-module__loader","lds-rolling":"applications-components-common-LoaderModule-loader-module__lds-rolling","message":"applications-components-common-LoaderModule-loader-module__message"};
    if(module.hot) {
      // 1791528100113
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  